import { Component, Input, OnInit} from '@angular/core';

import { LabOrder } from '../../shared/data/lab-order';

@Component({
  selector: 'app-lab',
  templateUrl: './lab.component.html',
  styleUrls: ['./lab.component.css']
})
export class LabComponent implements OnInit {

  @Input() labOrder: LabOrder;

  constructor(
  ) { }

  ngOnInit(): void {
  }

  // Disable lab field(s) if user is lab because the already knows who they are.
  isDisabled(): boolean {
    const disable = true;

    // update disable flag here, depending on user role.
    return disable;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/lab/lab.component.ts